import React, { useState } from 'react';
import ArrowLeft from '../../../../Assets/Arrow left.svg';
import { useDispatch, useSelector } from 'react-redux';
import { closePreview } from '../../../../Features/storefrontSlice';
import DesktopBanner from './DesktopComponents/DesktopBanner';
import CategorySectionDesktop from './DesktopComponents/CategorySectionDesktop';
import SingleBannerDesktop from './DesktopComponents/SingleBannerDesktop';
import CategoryCollectionDesktop from './DesktopComponents/CategoryCollectionDesktop';
import CustomCollectionDesktop from './DesktopComponents/CustomCollectionDesktop';
import OfferDisplayDesktop from './DesktopComponents/OfferDisplayDesktop';
import CarouselBannerDesktop from './DesktopComponents/CarouselBannerDesktop/CarouselBannerDesktop';
import AboutOneDesktop from './DesktopComponents/AboutOneDesktop';
import AboutTwoDesktop from './DesktopComponents/AboutTwoDesktop';
import AboutThreeDesktop from './DesktopComponents/AboutThreeDesktop';
import FeaturesOneDesktop from './DesktopComponents/FeaturesOneDesktop';
import FeaturesTwoDesktop from './DesktopComponents/FeaturesTwoDesktop';

const OPTIONS = { loop: true, duration: 60, }

function DesktopPreview() {
    const dispatch = useDispatch();

    const desktopVersionStack = useSelector((state) => state.storefront.desktopVersionStack);
    const desktopVersionIndex = useSelector((state) => state.storefront.desktopVersionIndex);

    const [pageType, setPageType] = useState('STORE');

    function changePageType(type) {
        setPageType(type);
    }

    function handleClosePreview() {
        dispatch(closePreview());
    }

    return (
        <div className='w-screen h-screen'>
            <div className="h-[50px] w-full pl-4 flex select-none">
                <div className="flex items-center gap-2">
                    <button onClick={handleClosePreview} className="size-11 flex items-center justify-center outline-none">
                        <img src={ArrowLeft} alt="" />
                    </button>

                    <p className='font-bold text-2xl text-[#121212]'>Store Preview</p>
                </div>
            </div>

            <div className="h-[calc(100%-50px)] w-full flex items-center justify-center">
                <div className="w-[700px] h-[90%] border border-[#757575] flex flex-col gap-4 overflow-y-scroll no-scrollbar pb-4">
                    <DesktopBanner />

                    <div className="w-full pb-[51.5px]"></div>

                    <div className="w-full flex justify-center">
                        <button onClick={() => changePageType('STORE')} className={`outline-none w-[116px] h-fit px-[10px] py-[5px] font-semibold text-[12px] leading-[18px] text-center border-b-2 ${pageType === 'STORE' ? 'border-primaryColor text-[#000000]' : 'border-transparent text-[#666666]'}`}>Store and Deals</button>

                        <button onClick={() => changePageType('ABOUT')} className={`outline-none w-[116px] h-fit px-[10px] py-[5px] font-semibold text-[12px] leading-[18px] text-center border-b-2 ${pageType === 'ABOUT' ? 'border-primaryColor text-[#000000]' : 'border-transparent text-[#666666]'}`}>About us</button>
                    </div>

                    {
                        pageType === 'STORE' && 
                        <>
                            {desktopVersionStack[desktopVersionIndex]?.versionData?.map(item => {
                                if(item.item.typeData === 'CATEGORY') {
                                    return (
                                        <CategorySectionDesktop 
                                            item={item} 
                                            key={item.id} 
                                        />
                                    )
                                }
                                if(item.item.typeData === 'SINGLE_BANNER') {
                                    return (
                                        <SingleBannerDesktop 
                                            item={item} 
                                            key={item.id} 
                                        />
                                    );
                                }
                                if(item.item.typeData === 'CAROUSEL_BANNER') {
                                    return (
                                        <CarouselBannerDesktop 
                                            item={item} 
                                            key={item.id} 
                                            options={OPTIONS} 
                                        />
                                    )
                                }
                                if(item.item.typeData === 'CATEGORY_COLLECTION_LIST') {
                                    return (
                                        <CategoryCollectionDesktop 
                                            item={item} 
                                            key={item.id} 
                                        />
                                    )
                                }
                                if(item.item.typeData === 'CUSTOM_COLLECTION_LIST') {
                                    return (
                                        <CustomCollectionDesktop 
                                            item={item} 
                                            key={item.id} 
                                        />
                                    )
                                }
                                if(item.item.typeData === 'OFFER_DISPLAY') {
                                    return (
                                        <OfferDisplayDesktop 
                                            item={item} 
                                            key={item.id} 
                                        />
                                    )
                                }
                                else return null;
                            })}
                        </>
                    }

                    {
                        pageType === 'ABOUT' && 
                        <>
                            {desktopVersionStack[desktopVersionIndex]?.storeAbout.map(item => {
                                if(item.item.TypeData === 'ABOUT1') {
                                    return (
                                        <AboutOneDesktop 
                                            key={item.id} 
                                            item={item} 
                                        />
                                    );
                                }
                                if(item.item.TypeData === 'ABOUT2') {
                                    return (
                                        <AboutTwoDesktop 
                                            key={item.id} 
                                            item={item} 
                                        />
                                    );
                                }
                                if(item.item.TypeData === 'ABOUT3') {
                                    return (
                                        <AboutThreeDesktop 
                                            key={item.id} 
                                            item={item} 
                                        />
                                    );
                                }
                                if(item.item.TypeData === 'FEATURE1') {
                                    return (
                                        <FeaturesOneDesktop 
                                            key={item.id} 
                                            item={item} 
                                        />
                                    );
                                }
                                if(item.item.TypeData === 'FEATURE2') {
                                    return (
                                        <FeaturesTwoDesktop 
                                            key={item.id} 
                                            item={item} 
                                        />
                                    );
                                }
                                else return null;
                            })}
                        </>
                    }
                </div>
            </div>
        </div>
    );
}

export default DesktopPreview;
